type Outcome = 'good' | 'not_great' | 'need_help' | 'no_answer';

const STALENESS_MS = 5 * 60 * 1000;

const STYLES: Record<Outcome, { label: string; cls: string; dot: string }> = {
  good: { label: 'Good', cls: 'bg-hs-success-soft text-hs-success-text', dot: 'bg-hs-success' },
  not_great: { label: 'Not great', cls: 'bg-hs-warning-soft text-hs-warning-text', dot: 'bg-hs-warning' },
  need_help: { label: 'Needs help', cls: 'bg-hs-danger-soft text-hs-danger-text', dot: 'bg-hs-danger' },
  no_answer: { label: 'No answer', cls: 'bg-hs-surface-alt text-hs-text-mute', dot: 'bg-hs-text-mute' },
};

function pill(cls: string, dot: string | null, label: string) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-hs-pill px-2.5 py-1 text-[12px] font-semibold ${cls}`}>
      {dot && <span className={`w-2 h-2 rounded-full ${dot}`} />}
      {label}
    </span>
  );
}

export function OutcomeBadge({ outcome, startedAt }: { outcome: Outcome | null; startedAt?: string }) {
  if (outcome && STYLES[outcome]) {
    const s = STYLES[outcome];
    return pill(s.cls, s.dot, s.label);
  }
  // No outcome yet — distinguish "in progress" from "no answer" when we know the start time.
  if (!startedAt) return pill('bg-hs-surface-alt text-hs-text-mute', null, 'No check-ins yet');
  const ageMs = Date.now() - Date.parse(startedAt);
  if (ageMs > STALENESS_MS) return pill('bg-hs-surface-alt text-hs-text-mute', null, 'No answer');
  return pill('bg-hs-surface-alt text-hs-text-mute', null, 'In progress');
}
